import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";

//ANT DESIGN IMPORTS
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";

//ANT DESIGN ICONS IMPORT
import { LeftOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../serviceProvider.config";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import CustomButton from "../../../components/custom/CustomButton";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const DeactivateServiceProvider = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [reasonOptions, setReasonOptions] = useState([]);

  useEffect(() => {
    getDeactivateTemplate();
  }, []);

  function onCancel() {
    navigate("/detail-service-provider", { state: state });
  }

  const getDeactivateTemplate = () => {
    const params = {
      commandParam: "deactivate",
    };
    const url = `${apiConfig.Clients}/template`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        let tempReasons = [];

        res?.narrations?.forEach((element) => {
          tempReasons.push({
            value: element.id,
            label: element.name,
          });
        });
        setReasonOptions(tempReasons);

        setIsLoading(false);
      }
    });
  };

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Clients}/${state.id}`;
    const params = {
      command: "deactivate",
    };

    const body = {
      deactivationDate: BOM.DateTime(formValues.deactivationDate, "only-date"),
      //   deactivationDate: dayjs(formValues.deactivationDate).format(
      //     "DD MMMM YYYY",
      //   ),
      deactivationReasonId: formValues.deactivationReasonId,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.deactivateServiceProviderMsg);
          navigate("/service-provider");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: () => {
          navigate("/service-provider");
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout
      pageItems={staticConfig.deactivateServiceProviderBreadcrumbItems}
      isEnableRightSidebar={true}
    >
      <TopContent pageTitle={labelConfig.deactivateServiceProvider} />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Service Provider: ${
                state?.agentId || state?.id
              }`}</Divider>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.deactivationReason}
                  name={"deactivationReasonId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.deactivationReason),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    placeholder={labelConfig.deactivationReason}
                    options={reasonOptions}
                    style={{ width: "100%", height: 44 }}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.deactivationDate}
                  name={"deactivationDate"}
                  initialValue={dayjs()}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.deactivationDate),
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={BOM.DisabledAfterCurrentDate}
                    style={{ width: "100%", height: 44 }}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default DeactivateServiceProvider;
